<template>
  <div>
    <div class="flex-gt-sm-100 flex-100 px-2">
      <!-- hidden input field to show error, if side effects are empty -->
      <validation-provider tag="div"
                           :name="path"
                           :ref="path"
                           :rules="{side_effect_must_be_filled: [isRequired, model.grad_maximal_2_oder_unbekannt, model.nebenwirkungen]}"
                           v-slot="{ errors }">
        <lx-alert-box v-show="errors[0]" color="red" class="my-2">
          {{ errors[0] }}
        </lx-alert-box>

        <v-text-field
          v-model="model"
          v-show="false"
          :error-messages="errors[0]"
        ></v-text-field>
      </validation-provider>
    </div>

    <!-- Grad_maximal2_oder_unbekannt -->

    <div class="my-2 flex-gt-sm-100 flex-100 layout-column">
      <div class="pa-2 mx-2 mb-4 mt-1 report layout-row layout-align-start-center"
           style="border:1px solid;border-radius: 9px;"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>

        <div class="layout-column" style="font-size: 14px;" :class="compColor.primeClass">
          <span class="mb-2">{{ $t('FORMS_DIVERSE.MODULE_CTCAE_HINT_PART_1') }}</span>
          <span>{{ $t('FORMS_DIVERSE.MODULE_CTCAE_HINT_PART_2') }}</span>
        </div>
      </div>

      <div class="mb-1 ml-3" :class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_CTCAE_GRADE_2_OR_LESS') }}</div>

      <div class="flex-gt-sm-100 flex-100 px-2 ml-1 layout-row">
        <validation-provider tag="div"
                             :name="path + '.grad_maximal_2_oder_unbekannt'"
                             :ref="path + '.grad_maximal_2_oder_unbekannt'"
                             rules=""
                             v-slot="{ errors }">
          <v-radio-group :dense="denseFields" v-model="model.grad_maximal_2_oder_unbekannt" row
                         class="pa-0 mb-0"
                         :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                         :error-messages="errors[0]">
            <v-radio
              label="K - Keine"
              value="K"
              @change="resetSideEffects()"
              :disabled="isDisabled"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode">
            </v-radio>
            <v-radio
              label="1 - mild"
              value="1"
              @change="resetSideEffects()"
              :disabled="isDisabled"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode">
            </v-radio>
            <v-radio
              label="2 - moderat"
              value="2"
              @change="resetSideEffects()"
              :disabled="isDisabled"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode">
            </v-radio>
            <v-radio
              label="U - unbekannt"
              value="U"
              @change="resetSideEffects()"
              :disabled="isDisabled"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode">
            </v-radio>
          </v-radio-group>
        </validation-provider>

        <div>
          <v-btn :color="compColor.primeColor"
                 :dark="compColor.isInDarkMode"
                 depressed
                 text
                 width="auto"
                 @click="resetRadioButtons('grad_maximal_2_oder_unbekannt')"
                 :class="{'mt-1': !denseFields}"
                 class="white--text text-none layout-row layout-align-start-center ml-n2 px-2 pt-1"
                 v-show="model.grad_maximal_2_oder_unbekannt && !isDisabled"
                 :disabled="!model.grad_maximal_2_oder_unbekannt || isDisabled"
                 :title="$t('buttons.deleteSelection.title')">
            <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass" size="24">mdi-arrow-left-bold</v-icon>
            <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
          </v-btn>
        </div>
      </div>

      <div class="ml-3" :class="compColor.primeClass">{{ $t('OR') }}</div>
    </div>

    <div class="layout layout-column mt-1 mb-2">
      <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
        <lx-btn :disabled="isDisabled"
                icon="add_circle"
                :color="compColor.primeColor"
                :iconColor="'white'"
                :tooltip="$t('FORMS_DIVERSE.MODULE_CTCAE_ADD')"
                :label="$t('FORMS_DIVERSE.MODULE_CTCAE_ADD')"
                iconSize="21"
                :width="'auto'"
                :height="35"
                classes="text-none"
                @click="addCTCAE(path + '.nebenwirkungen')"
        ></lx-btn>
      </div>

      <v-divider class="mb-2" v-bind:style="{'border-color':compColor.lightDivider}" v-if="model && model.nebenwirkungen && model.nebenwirkungen.length > 0"></v-divider>

      <div :key="index" v-for="(item, index) in model.nebenwirkungen"
           class="layout-row pa-0 ma-2"
           :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
           style="border-radius:4px;"
           :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">


        <div class="layout-row layout-wrap flex px-3">

          <!-- Art der Nebenwirkung -->

          <div class="flex-gt-sm-25 flex-100 px-2 py-3">
            <validation-provider tag="div"
                                 :name="path + '.nebenwirkungen.' + index + '.art'"
                                 :ref="path + '.nebenwirkungen.' + index + '.art'"
                                 rules="required|trim_string"
                                 v-slot="{ errors }">
              <lx-autocomplete
                :label="$t('FORMS_DIVERSE.MODULE_CTCAE_KIND_OF_CTCAE') + ' *'"
                v-model="item.art.bezeichnung"
                :error="errors[0]"
                @search-method="getDataForAutocomplete"
                @input="setCtcae"
                :length="3"
                :disabled="isDisabled"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :hint="$t('FORMS_DIVERSE.MODULE_CTCAE_KIND_OF_CTCAE_HINT')"
                :persistent_hint="true"
                :index="index"
                :title="item.nebenwirkung_art"
                :results="resultSearchModel">
                <template v-slot="slotProps">
                  <div class="layout-row">
                    <div style="width: 350px;border-radius: 4px; word-wrap: normal;"
                         class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                      <h4>
                        <lx-text-highlight :text="slotProps.lineItem.event"
                                           :search-string="slotProps.searchText"
                                           :color="compColor.prime"></lx-text-highlight>
                      </h4>
                    </div>
                    <div class="flex">
                      <span class="body-2">
                        <lx-text-highlight :text="slotProps.lineItem.synonyms" :search-string="slotProps.searchText"
                                           :color="compColor.prime"></lx-text-highlight>
                      </span>
                    </div>
                  </div>
                </template>
              </lx-autocomplete>
            </validation-provider>
          </div>

          <!-- Grad der Nebenwirkung -->

          <div class="flex-gt-sm-50 flex-100 px-2 py-3">
            <validation-provider tag="div"
                                 :name="path + '.nebenwirkungen.' + index + '.grad'"
                                 :ref="path + '.nebenwirkungen.' + index + '.grad'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_CTCAE_KIND_OF_CTCAE_GRADING') + ' *'"
                v-model="item.grad"
                :items="setGradingsList(item.gradings)"
                outlined
                class="ma-0"
                :hide-details="!errors || errors.length <= 0"
                :disabled="isDisabled"
                :dense="denseFields"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Grad der Nebenwirkung -->

          <div class="flex-gt-sm-25 flex flex-100 px-2 py-3">
            <validation-provider tag="div"
                                 :name="path + '.nebenwirkungen.' + index + '.version'"
                                 :ref="path + '.nebenwirkungen.' + index + '.version'"
                                 rules="required"
                                 v-slot="{ errors }">
              <v-select
                  :color="compColor.primeColor"
                  :label="$t('FORMS_DIVERSE.MODULE_CTCAE_KIND_OF_CTCAE_VERSION') + ' *'"
                  v-model="item.version"
                  :items="Nebenwirkung_VersionTypes"
                  outlined
                  class="ma-0"
                  :hide-details="!errors || errors.length <= 0"
                  :disabled="isDisabled"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ item.text }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>
        </div>

        <div class="layout-column layout-align-center-center px-3"
             :class="{'grey lighten-2': !compColor.isInDarkMode}"
             :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
          <lx-btn @click="deleteItem(path + '.nebenwirkungen', index, path + '.nebenwirkungen.' + index + '.nebenwirkung_grad')"
                  :color="compColor.primeColor"
                  :iconColor="'white'"
                  iconSize="21"
                  :width="35"
                  :height="35"
                  :disabled="isDisabled" icon="delete_forever"></lx-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'
import LxAutocomplete from '../../lx_auto_complete/LxAutocomplete'
import LxTextHighlight from '../../lx_text_highlighter/LxTextHighlight'

export default {
  name: "Nebenwirkugen",
  mixins: [metaData, utils],
  components: {
    LxAutocomplete,
    LxTextHighlight
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    addCtcaeItem: {
      type: Function
    },
    deleteCtcaeItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    isRequired: {
      type: Boolean
    },
    disableManuallyValidate: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: {},
      Nebenwirkung_GradTypes: null,
      Nebenwirkung_VersionTypes: null,
      resultSearchModel: {}
    }
  },
  created () {
    this.Nebenwirkung_GradTypes = this.formsMetaData.Nebenwirkung_GradTypes
    this.Nebenwirkung_VersionTypes = this.formsMetaData.Nebenwirkung_VersionTypes
  },
  methods: {
    /**
     * Validate side effects separately after changing elements in side effects
     */
    validateComplication () {
      this.$refs[this.path].validate()
    },

    /**
     * Reset list of side effects after choosing grade 2 or less
     */
    resetSideEffects () {
      this.model.nebenwirkungen = null
      this.validateComplication()
    },

    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field) {
      this.$delete(this.model, field)
      this.validationRef.fields[this.path + '.' + field].changed = true
      this.validateComplication()
    },

    /**
     *  Add new element to list of side effects, reset grade 2 or less
     *
     * @param path
     */
    addCTCAE (path) {
      this.addCtcaeItem(path, { art: {}})
      this.model.grad_maximal_2_oder_unbekannt = null
      this.validateComplication()

    },

    /**
     * Delete selected element of side effects and trigger validator for saving
     */
    deleteItem (path, index, field) {
      this.deleteCtcaeItem(path, index)
      this.validateComplication()

      // trigger validator only in documentation and not in import
      if (!this.disableManuallyValidate) {
        this.validationRef.fields[field].changed = true
      }
    },

    /**
     * Set selection for grading of ctcae with on element saved list or default list
     */
    setGradingsList (itemGradings) {
      return itemGradings || this.Nebenwirkung_GradTypes
    },

    /**
     * Get list of ctcae via regex in auto-complete
     *
     * @param data
     * @param index
     */
    getDataForAutocomplete (data, index) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)

      // reset resultModel to display the correct results after db-request
      this.resultSearchModel = {}

      this.$http.get('/ctcae/search?config={"opts":{}, "query": {"searchValue":"' + data + '"}, "count":true}')
        .then(res => {
          // give index of selected array-element to component to ensure, that only popup of selected element will be opened and not all
          res.data.index = index
          this.resultSearchModel = res.data
        })
        .catch(this.NotifyError)
    },

    /**
     * Set ctcae and gradings after input
     *
     * @param data
     * @param index
     */
    setCtcae (data, index) {
      this.$set(this.model.nebenwirkungen[index], 'art', {bezeichnung:data && data.event ? data.event : data, meddra_code: data && data.meddra ? data.meddra : null })
      this.$set(this.model.nebenwirkungen[index], 'grad', null)
      this.$set(this.model.nebenwirkungen[index], 'gradings', data && data.gradings ? data.gradings : this.formsMetaData.Nebenwirkung_GradTypes)

      // set version only, if not already exists
      if (!this.model.nebenwirkungen[index].version) {
        this.$set(this.model.nebenwirkungen[index], 'version', '4')
      }

      // set grading automatically, if only on item in selection exists
      if (this.model.nebenwirkungen[index].gradings && this.model.nebenwirkungen[index].gradings.length === 1) {
        this.$set(this.model.nebenwirkungen[index], 'grad', this.model.nebenwirkungen[index].gradings[0].value)
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
